export default __webpack_public_path__ + "static/media/Background.61c6e430.png";